module.exports = __webpack_public_path__ + "img/5price.a50f9c15.png";